<div class="flex flex-row h-full">
    <div class="grow h-full">
        <ng-content></ng-content>
    </div>
    <div class="h-full">
        <ng-content select="#profilePart"></ng-content>
    </div>
</div>